import React, { useCallback, useState } from 'react';
import CertsTab from '../tabs/CertsTab';
import ListingsTab from '../tabs/ListingsTab';
import OrdersTab from '../tabs/OrdersTab';
import ImageZoomModal from './ImageZoomModal';
import './BrokerContent.css';

const BrokerContent = ({
    tab,
    brokerEmail,
    filters,
    goTo,
    onTabCount,
}) => {
    const [zoomImage, setZoomImage] = useState(null);
    const openZoom = useCallback((src) => setZoomImage(src), []);
    const closeZoom = useCallback(() => setZoomImage(null), []);

    // Stable per-tab callbacks. A fresh function each render would change the
    // tab's onCountChange prop, re-running its load effect — so opening the zoom
    // modal (which re-renders this component) would refetch /mine every time.
    const reportCertsCount = useCallback((n) => onTabCount?.('certs', n), [onTabCount]);
    const reportListingsCount = useCallback((n) => onTabCount?.('listings', n), [onTabCount]);
    const reportOrdersCount = useCallback((n) => onTabCount?.('orders', n), [onTabCount]);

    return (
        <section className="broker-content">
            {tab === 'certs' && (
                <CertsTab
                    brokerEmail={brokerEmail}
                    filters={filters}
                    goTo={goTo}
                    onZoom={openZoom}
                    onCountChange={reportCertsCount}
                />
            )}
            {tab === 'listings' && (
                <ListingsTab
                    brokerEmail={brokerEmail}
                    filters={filters}
                    goTo={goTo}
                    onZoom={openZoom}
                    onCountChange={reportListingsCount}
                />
            )}
            {tab === 'orders' && (
                <OrdersTab
                    brokerEmail={brokerEmail}
                    filters={filters}
                    goTo={goTo}
                    onCountChange={reportOrdersCount}
                />
            )}
            <ImageZoomModal src={zoomImage} onClose={closeZoom} />
        </section>
    );
};

export default BrokerContent;
